import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Axios from "axios";
import { API_BASE_URL, GET_VSTORE_PROD, INSERT_PROD } from "../../../Config";
import Swal from "sweetalert2";

const StockadjustmentModal = ({ selectedId }) => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [storeProducts, setStoreProducts] = useState([]);
  // const [initialStoreProducts, setInitialStoreProducts] = useState([]);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (!userDataSession.OrgId) return;
    console.log(selectedId, "selected id");
    setLoading(true);
    const fetchData = () => {
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: "0",
        IsActive: 1,
        ProductId: selectedId,
        StoreId: 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 1,
      };
      console.log(requestData, 'data sening to api fro store prods')

      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          setLoading(false);
          const productsWithAdjustStock = response.data.ResultData.map(
            (product) => ({
              ...product,
              AdjustStock: "",
            })
          );
          setStoreProducts(productsWithAdjustStock);
          console.log(productsWithAdjustStock,'productsWithAdjustStock' )
          // setInitialStoreProducts(productsWithAdjustStock);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching data:", error);
        });
    };

    fetchData();
  }, [selectedId, userDataSession.OrgId]);

  const handleQuantityChange = (index, value) => {
    const updatedProducts = [...storeProducts];
    updatedProducts[index].AdjustStock = parseInt(value, 10) || "";
    setStoreProducts(updatedProducts);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitBtnLoading(true);

    const requestData = {
      orgid: `${userDataSession.OrgId}`,
      userid: `${userDataSession.UserId}`,
      Product: {},
      StoreProduct: storeProducts.map((item) => ({
        Id: item.StoreProductId,
        StoreId: item.StoreId,
        InStock: item.InStock + item.AdjustStock,
      })),
      ProductVariants: [],
      OperationType: "Update",
    };

    console.log(requestData, "data sending to api");

    Axios.post(`${API_BASE_URL}${INSERT_PROD}`, requestData)
      .then((response) => {
        setSubmitBtnLoading(false);
        if (response.data[0].Success == 1) {
          setSubmitBtnLoading(false);
          Swal.fire({
            title: `Stock Updated Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              setSubmitBtnLoading(false);
              window.location.reload();
            }
          });
        } else {
          setSubmitBtnLoading(false);
          // Show success message
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setSubmitBtnLoading(false);
        console.error("Error:", error);
      });
  };

  const handleCancelClick = () => {
    const productsWithAdjustStock = storeProducts.map((product) => ({
      ...product,
      AdjustStock: "",
    }));
    setStoreProducts(productsWithAdjustStock);
  };

  return (
    <div>
      {/* Edit Adjustment */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditStockAdj"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "55%", maxWidth: '55%' }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Adjust Stock</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={handleCancelClick}
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <form onSubmit={handleSubmit}>
            <div className="d-flex" style={{ marginTop: '-0.5rem' }}>
              <label>Product:</label>
              <h5 className="ms-2 text-primary">{storeProducts.length > 0 ? storeProducts[0].ProductName : ""}</h5>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="modal-body-table">
                  <div className="table-responsive" style={{ maxHeight: '25rem', overflowy: 'auto' }}>
                    <table className="table  datanew">
                      <thead >
                        <tr className="sticky-top">
                          <th>#</th>
                          <th>Store</th>
                          <th>BarCode</th>
                          {/* <th>SKU</th> */}
                          <th>Current Stock</th>
                          <th>Adjust Stock</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="12">
                              <div className="d-flex justify-content-center align-items-center">
                                <div className="loader">
                                  {/* <span className="sr-only">Loading...</span> */}
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          storeProducts.map((item, index) => (
                            <tr key={index}>
                              <th>{index + 1}</th>
                              <td>{item.StoreName}</td>
                              <td>{item.BarCode}</td>
                              {/* <td>{item.ProductSKU}</td> */}
                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={item.InStock}
                                  style={{
                                    maxWidth: "8rem",
                                    cursor: "not-allowed",
                                  }}
                                  readOnly
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{ maxWidth: "8rem" }}
                                  placeholder="Enter qty"
                                  value={item.AdjustStock}
                                  onChange={(e) =>
                                    handleQuantityChange(index, e.target.value)
                                  }
                                  onWheel={(e) => e.target.blur(e)}
                                />
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer-btn sticky-bottom">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                {submitBtnLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

StockadjustmentModal.propTypes = {
  selectedId: PropTypes.number.isRequired,
};

export default StockadjustmentModal;
